/** i18n namespace for this tab's own strings. Registered in `src/index.js`. */
export const I18N_NAMESPACE = 'rangePlanProductIdentifier';

/**
 * The tab's api name, download key and workbook file type.
 *
 * Three separate vocabularies for one tab is not a tidy design, but it is the one already in
 * `ProductListNew.js`: the api name is kebab-case, the download key is camelCase, and the file
 * type is snake_case. Naming all three here is what keeps them in step.
 */
export const RP_IDENTIFIER_API_NAME = 'product-identifier-v2';

/**
 * The download key is deliberately NOT flag-derived.
 *
 * `downloadSelectedInfo` is consumed by two places that both key off the literal string: the cron's
 * `newDownloadSheets` allowlist, which decides whether a job reaches the new module builder at all,
 * and `productListingTabsOptions()`, which supplies the output filename. A v2-specific value misses
 * both — the job silently routes to the legacy builder and dies on an ObjectId cast, and the file
 * would be named Product_Information.
 *
 * Keeping one value also means jobs queued before a deploy still run.
 */
export const RP_IDENTIFIER_DOWNLOAD_KEY = 'productIdentifier';

/** Workbook discriminator, paired with `EXPORT_FILE_TYPE` on the server. A v1 sheet must not match. */
export const RP_IDENTIFIER_FILE_TYPE = 'product_identifier_v2';

/**
 * Structural column ids, prefixed so they can never collide with a `ProductIdentifierMaster._id`.
 *
 * There is deliberately no grading-group column. BM-9580 replaced the legacy grading-library
 * `tabId` with a typed `sizeRangeId`, so grading group is not an axis of a v2 combination and a
 * column for it would be showing a relationship the data no longer has. Size Range is a real
 * server column and carries what that column used to imply.
 */
export const SELECT_COLUMN_ID = '__rp_pi_select';
export const EXPAND_COLUMN_ID = '__rp_pi_expand';
export const IMAGE_COLUMN_ID = '__rp_pi_image';

/**
 * Total combinations across the page above which expand-all asks for confirmation first.
 *
 * Expanding every product at once can mount tens of thousands of table rows in a single commit.
 * Below this the pause would be noise; above it the user should be the one choosing to wait.
 */
export const EXPAND_ALL_CONFIRM_THRESHOLD = 2000;

/** Placeholder for an empty cell, matching the v1 table and the exported sheet. */
export const EMPTY_CELL = '--';

/** Range Plan tab key the Product Identifier grid is shown under. */
export const RP_IDENTIFIER_TAB_KEY = 'product-identifier';
